export function buildMediaUrl(track, API_URL, kind) {
  const creator = encodeURIComponent(track.creator)
  const title = encodeURIComponent(track.title)

  if (track.type === 'audio-book') {
    if (kind === 'audio') {
      return `${API_URL}/book/${creator}/chapter/${title}`
    } else if (kind === 'cover') {
      return `${API_URL}/book/${creator}/cover`
    }
  } else if (track.type === 'music') {
    if (kind === 'audio') {
      return `${API_URL}/artist/${creator}/song/${title}`
    } else if (kind === 'cover') {
      return `${API_URL}/artist/${creator}/cover/${title}`
    }
  }
}
